Vendd.Scripts.load(function () {

    var defOptions = {
        navigation: true,
        pagination: true,
        items: 3,
        slideSpeed: 600,
        scrollPerPage: true,
        paginationSpeed: 600,
        addClassActive: true,
        navigationText: ["<span class='icon icon-arrow-light-left'></span>", "<span class='icon icon-arrow-light-right'></span>"],
        autoPlay: 3000,
        lazyLoad: false
    };

    function initOwlSlider(container, options) {

        if ($(container).length > 0) {

            var $wrapper = $(container).closest('.x-slider');
            //var timeout = $wrapper.data('timeout') ? $wrapper.data('timeout') : false;
            //var speed = $wrapper.data('speed') ? $wrapper.data('speed') : 600;

            if (!$wrapper.data('init'))
                return;

            //options.autoPlay = timeout;
            //options.slideSpeed = speed;
            //options.paginationSpeed = speed;

            var opts = $.extend({}, defOptions, options);
            if ($wrapper.data("detailed-pager")) {
              opts.afterUpdate = function() {
                assignPagerValues($wrapper);
              };
              opts.afterInit = function() {
                assignPagerValues($wrapper);
              };
            }

            container.owlCarousel(opts);
        }
    }

    initOwlSlider($('.news-slider > ul'), { singleItem: true, rewindSpeed: 1500});

    initOwlSlider($('.home-page .homepage-slider > ul'), { 
        singleItem: true, 
        transitionStyle: "fade", 
        autoPlay: 3000 ,
        afterAction : function(elem) {
            var selectedSlide = $(elem).find(".owl-item.active");
            var pagination = $(elem).find(".owl-pagination");
            if (selectedSlide.hasClass("theme-Dark")) {
                pagination.addClass("theme-Dark");
            } else {
                pagination.removeClass("theme-Dark");
            }
          }
    });

    initOwlSlider($('.home-page .brand-list'), { items: 4, autoPlay: 3000, itemsDesktop: [1199,4], itemsDesktopSmall: [979,4], itemsTablet: [768,3], itemsMobile: [479, 2] });
    initOwlSlider($('.home-page .x-product-slider > ul'), { items: 4, itemsDesktop: [1199, 3], itemsDesktopSmall: [900, 2], itemsTablet: [735, 2], itemsMobile: [479, 1], rewindNav: false, mouseDrag: false, touchDrag: true });

    function assignPagerValues(wrapper) {
      if (!wrapper || wrapper.length < 1) return;

      var items = $("> ul > .owl-wrapper-outer > .owl-wrapper > .owl-item",wrapper);
      var pages = $("> ul > .owl-controls > .owl-pagination > .owl-page",wrapper);

      items.each(function(index, item) {
        $("span", pages.eq(index)).html(index+1);
      
      });
    }
});